import {equals} from 'ol/coordinate.js';
import Feature from 'ol/Feature.js';
import Geolocation from 'ol/Geolocation.js';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import type {Map} from 'ol';

// FIXME: move elsewhere (this is geoblockisable)
// don't depend on OL
// think about the generic class of usages
export class GeolocationHelper {
  error = false;
  private map: Map;
  private geolocation: Geolocation;
  private layer: VectorLayer<VectorSource>;

  constructor(map: Map) {
    this.map = map;
    this.geolocation = new Geolocation({
      tracking: false,
      projection: this.map.getView().getProjection(),
      trackingOptions: {
        maximumAge: 10000,
        enableHighAccuracy: true,
        timeout: 600000,
      },
    });

    const accuracyFeature = new Feature();
    const positionFeature = new Feature();
    const source = new VectorSource({
      features: [accuracyFeature, positionFeature],
    });

    this.geolocation.on('error', () => (this.error = true));

    this.geolocation.on('change:accuracyGeometry', () => {
      accuracyFeature.setGeometry(this.geolocation.getAccuracyGeometry());
    });

    this.geolocation.on('change:position', () => {
      const coordinates = this.geolocation.getPosition();
      const view = this.map.getView();
      const center = view.getCenter();
      if (!equals(coordinates, center)) {
        // follow the device position
        view.setCenter(coordinates);
        // FIXME: fit the accuracyGeometry ?
        view.setZoom(20);
      }
      positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
      this.error = false;
    });

    this.layer = new VectorLayer({
      zIndex: 100,
      visible: false,
      source: source,
    });

    this.map.addLayer(this.layer);
  }

  set tracking(tracking: boolean) {
    this.geolocation.setTracking(tracking);
    this.layer.setVisible(tracking);
  }

  get tracking(): boolean {
    return this.geolocation.getTracking();
  }
}
